module.exports = __webpack_public_path__ + "img/ring_g_o_1_null@2x.4eb49469.png";